var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',{staticClass:"sr-only"},[_vm._v("Accessibility Links")]),_c('a',{staticClass:"skip-nav",attrs:{"href":"#main"}},[_vm._v("Skip to main content")]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }